import z from 'zod/v4';
import { createPresetSchema } from './utils';
import { DefaultPresetSchema } from './default-preset-schema';
import type { PresetConfig } from './types';

const V1DataSchema = z.object({
  menuVisibility: z.record(z.string(), z.boolean()),
  menuOrder: z.record(z.string(), z.string()),
  expandedItems: z.record(z.string(), z.array(z.string())),
});

export const V1Schema = createPresetSchema('1', V1DataSchema);

export const SIDEBAR_ORDER_PRESET_IDENTIFIER = 'sidebar.order';

const SidebarOrderPresetSchema = z.object({
  ...DefaultPresetSchema.shape,
  context: z.literal(SIDEBAR_ORDER_PRESET_IDENTIFIER),
  data: V1Schema,
});

export const SidebarOrderPreset = {
  identifier: SIDEBAR_ORDER_PRESET_IDENTIFIER,
  currentSchema: SidebarOrderPresetSchema,
  currentVersion: '1',
  migrations: null,
  single: true,
} as const satisfies PresetConfig;
